import { CharacteristicFilter } from './CharacteristicFilter';
import { CharacteristicList } from './CharacteristicList';

export const list = CharacteristicList;
export const filter = CharacteristicFilter;
